"use client";

import { segmentEvent } from "@/utils/segmentfunctions";

/** Public Store Locator Widgets id, already shipped in the legacy site bundle. */
const STORE_LOCATOR_UID = process.env.NEXT_PUBLIC_STORELOCATOR_UID;

let resultsInterval: number | undefined;
let observer: MutationObserver | undefined;

function attachEvents() {
  const searchAddress = document.getElementById("storelocator-search_address");
  if (!searchAddress || searchAddress.dataset.bound === "true") return;
  searchAddress.dataset.bound = "true";

  const stores = document.getElementsByClassName("storelocator-store");
  const results = document.getElementById("storelocator-results");
  const showResults = () => {
    if (!results) return;
    const amount = [...stores].length;
    results.innerText = `Showing ${amount} result${amount === 1 ? "" : "s"}`;
  };
  resultsInterval = window.setInterval(showResults, 1000);

  document.querySelectorAll(".storelocator-phone").forEach((link) => {
    link.addEventListener("click", (event) => {
      const text = (event.target as HTMLElement).innerText;
      segmentEvent("Marketing CTA Clicked", { destination: text, text: "Call", type: "Button" });
    });
  });

  const search = document.getElementById("storelocator-search");
  search?.appendChild(searchAddress);

  const distance = document.getElementById("storelocator-distance-container");
  if (!distance) return;
  let radius = document.getElementById("storelocator-radius-container");
  if (!radius) {
    radius = document.createElement("div");
    radius.id = "storelocator-radius-container";
    const nearby = document.getElementById("storelocator-nearby");
    if (nearby) distance.appendChild(nearby);
    distance.appendChild(radius);
  }
  const radiusLabel = document.getElementById("search_radius_text");
  const radiusSelect = document.getElementById("storelocator-search-radius");
  if (radiusLabel) radius.appendChild(radiusLabel);
  if (radiusSelect) radius.appendChild(radiusSelect);
}

export function renderMap() {
  const mount = document.getElementById("map-script");
  const widget = document.getElementById("storelocatorwidget");
  if (!mount || !widget) return;

  const mapbox = document.createElement("script");
  mapbox.classList.add("mapbox-gl-require");
  mapbox.src = "https://cdn.storelocatorwidgets.com/widget/mapbox-gl-requirejs.js";
  mount.appendChild(mapbox);

  const widgetScript = document.createElement("script");
  widgetScript.id = "storelocatorscript";
  widgetScript.setAttribute("data-uid", STORE_LOCATOR_UID);
  widgetScript.setAttribute("data-platform", "MapTiler");
  widgetScript.src = "https://cdn.storelocatorwidgets.com/widget/widget.js";
  mount.appendChild(widgetScript);

  observer = new MutationObserver(() => {
    window.setTimeout(attachEvents, 1000);
  });
  observer.observe(widget, { attributes: true, childList: true, characterData: true });
}

export function cleanUpMap() {
  if (resultsInterval) window.clearInterval(resultsInterval);
  resultsInterval = undefined;
  observer?.disconnect();
  observer = undefined;
  document.querySelector(".mapbox-gl-require")?.remove();
  document.getElementById("storelocatorscript")?.remove();
}
